"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgWrench = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M23.701 4.912a.505.505 0 00-.84-.201L19.27 8.3a.505.505 0 01-.404.145l-2.62-.238a.505.505 0 01-.458-.456l-.236-2.622a.505.505 0 01.146-.404l3.594-3.593a.505.505 0 00-.202-.838 7.256 7.256 0 00-7.208 1.864 7.052 7.052 0 00-1.604 7.573.494.494 0 01-.1.537L.802 19.63a2.606 2.606 0 00-.606 2.874 2.54 2.54 0 004.094.768l9.429-9.427a.498.498 0 01.537-.1 7.045 7.045 0 007.575-1.582 7.29 7.29 0 001.87-7.252z" })));
};
exports.default = SvgWrench;
//# sourceMappingURL=Wrench.js.map